export const ENV_DEFAULTS = {
    apiProxy: 'https://localhost:7058/',
    icmsTransparente: 'https://hom.efazenda.servicos.ms.gov.br/',
} as const;

export function readPublicEnv(name: keyof ImportMetaEnv, fallback: string): string {
    const value = import.meta.env[name]?.trim?.() ?? import.meta.env[name];
    if (typeof value === 'string' && value.length > 0) {
        return value;
    }
    return fallback;
}
